import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Paper, Tab, Tabs, Button, Typography} from '@material-ui/core';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import AvatarUpload from './components/AvatarUpload';
import ChangePassword from './components/ChangePassword';
import NewChangePassword from './components/NewChangePassword';
import { FusePageCarded } from '@fuse';
import InstructorQualificationProfile from '../instructor/InstructorQualificationsProfile';
import * as Actions from './store/actions';
import * as HelperFunctions from '../../components/helpers'; 

const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64,
        flex: 1
    },
    tabRoot: {
        height: 64,
        [theme.breakpoints.up('md')]: {
            minWidth: '144px'
        }
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
        minWidth: '80%',
        maxWidth: '80%'
    },
    pwWrapper: {
        padding: 10
    },
    spacer: {
        height: 20
    },
    roleButtons: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center', 
        alignContent: 'center',
    }
});

class Profile extends Component {
    state = {
        current_tab: 0,
        tabValue: 0,
    }

    handleChangeTab = (event, value) => {
        this.setState({
            ...this.state,
            current_tab: value
        })
    }

    handleRoleChangeClick = (auth_id, role_id, link_id, company_id) => {
        this.props.toggleActiveAuthRole(auth_id, role_id, link_id, company_id)
    }

    getButtonDisplay = (role) => {
        if (role.role_id === 5) {
            return 'Company ' + '(' + role.link_info.CompanyName + ')';
        }
        if (role.role_id === 3) {
            return 'Instructor ' + '(' + role.link_info.CompanyName + ')';
        }
        return role.RoleName
    }

    getInactiveRoles = () => {
        const roleButtons = this.props.auth.user.all_roles.map(role => {
            return (
                <Button
                    style={{ minHeight: '70px', maxHeight: '70px', fontSize: '12px' }}
                    key={role.role_id + role.link_id + ' ' + role.company_id}
                    variant="contained"
                    color={role.Active === 1 ? 'primary' : 'default'}
                    className={this.props.classes.styles}
                    onClick={() => this.handleRoleChangeClick(role.auth_id, role.role_id, role.link_id, role.company_id)}
                >
                    {this.getButtonDisplay(role)}
                </Button>
            )
        })
        return roleButtons
    }

    getPageContent = (current_tab) => {
        const classes = this.props.classes
        const auth = this.props.auth
        switch (current_tab) {
            case (0):
                {
                    return (
                        <Grid container spacing={24}>
                            <Grid item xs={8}>
                                {/* <Paper>
                                    <div className={classes.pwWrapper}>
                                        <h2 className='flex flex-col items-center justify-center'>Current User Role: {auth.user.role.charAt(0).toUpperCase() + auth.user.role.slice(1)}</h2>
                                        <div className={classes.roleButtons}>
                                            {this.getInactiveRoles()}
                                        </div>
                                    </div>
                                </Paper> */}
                                <div className={classes.spacer}></div>
                                <Paper>
                                    <div className={classes.pwWrapper}>
                                        <NewChangePassword  />
                                    </div>
                                </Paper>
                                <br />
                            </Grid>
                            <Grid item xs={4}>
                                <Paper>
                                    <div className={classes.pwWrapper}>
                                        <img className={classes.profilePic} src={auth.user.data.photoURL} />
                                    </div>
                                    <Paper>
                                        <div className={classes.pwWrapper}>
                                            <AvatarUpload old_asset_id={auth.user.data.photoID} auth_id={auth.user.data.auth_id} />
                                        </div>
                                    </Paper>
                                </Paper>
                            </Grid>
                        </Grid>
                    )
                }
            case (1):
                {
                    return (
                        <InstructorQualificationProfile />
                    )
                }
        }
    }

    render() {
        const { current_tab } = this.state;
        const { auth, classes } = this.props;
        const pageContent = this.getPageContent(current_tab)

        return (

            <FusePageCarded
                classes={{
                    root: classes.layoutRoot,
                    toolbar: classes.layoutToolbar
                }}
                header={
                    <div className="py-24"><h4>Profile</h4></div>
                }
                contentToolbar={
                    <div style={{ width: '100%', height: '100%', }}>
                            <Tabs
                                value={current_tab}
                                onChange={this.handleChangeTab}
                                indicatorColor="primary"
                                textColor="primary"
                                classes={{
                                    root: classes.tabsRoot
                                }}
                                scrollable={true}
                            >
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Profile"
                                />
                                {!HelperFunctions.checkPermission(this.props.auth.user.data.permissionList, "qualification", "edit") ? null :
                                    <Tab
                                        classes={{
                                            root: classes.tabRoot
                                        }}
                                        label="Qualifications"
                                        hidden={auth.user.role != 'instructor'}
                                    />
                                }
                            </Tabs>
                    </div>
                }
                content={
                    <React.Fragment>
                        <div className="p-24">
                            {pageContent}
                        </div>
                    </React.Fragment>
                }
            />
        )
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        toggleActiveAuthRole: Actions.toggleActiveAuthRole,
    }, dispatch);
}

function mapStateToProps({ dashboardApp, auth }) {
    return {
        auth,
        // passwordChanged: auth.passwordchange.passwordChanged
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Profile)));



// WEBPACK FOOTER //
// src/main/content/dashboard/Profile.js